<app-go-to-project></app-go-to-project>
<app-gallery [galleryId]="'1'" [(section)]="section" [autoPlay]="true"
[showThumbs]="true" class="simpleGal images scroll"></app-gallery>